
import { productHomeDeepLinkBuilder } from '@core/helpers/deepLink'
import { createObserver } from '@core/helpers/vue-Intersection-observer'
import HighlightedProductCard from '@recommendation/components/HighlightedProductCard/HighlightedProductCard.vue'
import { toTrackingData } from '@recommendation/recommendationAdapter'
import {
  PRODUCT_DEAL_TYPE,
  PRODUCT_PROVIDERS,
  PRODUCT_SOURCE,
  PRODUCT_SOURCE_TYPE,
  saveProductInfos,
} from '@tracking'
import { trackProductClick } from '@tracking/events'

export default {
  components: {
    HighlightedProductCard,
  },

  props: {
    product: { type: Object, required: true },
    cardWidth: { type: String, default: 'standard' },
    position: { type: Number, default: -1 },
    widgetId: { type: String, default: undefined },
  },

  computed: {
    trackingInformations() {
      return {
        widgetId: this.recommendationWidgetId,
      }
    },

    trackingData() {
      return toTrackingData(this.product, {
        dealType: PRODUCT_DEAL_TYPE.NORMAL,
        list: PRODUCT_SOURCE_TYPE.HIGHLIGHTED_PRODUCT,
        position: this.position,
        provider: PRODUCT_PROVIDERS.EARLYBIRD,
        source: PRODUCT_SOURCE.RECOMMENDATIONS,
        widgetId: this.widgetId,
        deepLink: productHomeDeepLinkBuilder({ $route: this.$route }),
      })
    },
  },

  destroyed() {
    this.unobserveCard()
  },

  mounted() {
    if (this.product.link) {
      this.watchCardInViewport()
    }
  },

  updated() {
    if (this.product.link) {
      this.watchCardInViewport()
    }
  },

  methods: {
    handleClick() {
      trackProductClick(this.trackingData)

      saveProductInfos({
        id: this.product.id,
        price: this.product.price.amount,
        source: PRODUCT_SOURCE_TYPE.HIGHLIGHTED_PRODUCT,
      })

      this.$emit('product-click')
    },

    unobserveCard() {
      if (this.unobserve) {
        this.unobserve()
      }
    },

    watchCardInViewport() {
      this.unobserveCard()
      this.unobserve = createObserver(this.$el, () => {
        this.$emit('viewport-impression', this.trackingData.product)
      })
    },
  },
}
